import {
  ListViewResultIcon,
  ListViewResultMeta,
  ListViewResultRow,
  ListViewResultSection,
  ListViewResultTitle,
  SearchResultItem,
  StyledSearchResultsItemTitle,
} from "../../../../share/searchResults";
import { formatSearchResultTitle } from "../../../../util/stringUtil";
import Np from "../../../../assets/svg/personIcon.svg";
import { useActions } from "../../../../hooks/useActions";
import useSearchParams from "../../../../hooks/useSearchParams";
import { CurrentPerson } from "../../../../models/CurrentPerson";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import useMobileScreen from "../../../../hooks/useMobileScreen";
import { breakpoints } from "../../../../constants";

type Props = {
  key: number;
  mapObject: CurrentPerson;
};

const PersonsSearchResultItem = ({ key, mapObject }: Props) => {
  const { setCurrentMarker } = useActions();
  const { setSearchParam } = useSearchParams();
  const isListViewActive = useTypedSelector(
    (state) => state.mapInterface.isListViewActive
  );
  const isMobile = useMobileScreen(breakpoints.medium);
  const shouldRenderListView = isListViewActive && !isMobile;

  const handleClickSearchResult = (mapObject: CurrentPerson) => {
    const hashId = mapObject.RECORD;
    setSearchParam("hash_id", hashId);
  };

  return (
    <SearchResultItem
      hashId={mapObject.hash}
      onMouseEnter={() =>
        setCurrentMarker({
          lon: +mapObject.lat,
          lat: +mapObject.lon,
        })
      }
      onMouseLeave={() => setCurrentMarker({ lon: 0, lat: 0 })}
      onClick={() => handleClickSearchResult(mapObject)}
    >
      {shouldRenderListView ? (
        <ListViewResultRow>
          <ListViewResultIcon>
            <img src={Np} alt="" />
          </ListViewResultIcon>
          <ListViewResultSection flex="2 1 320px">
            <ListViewResultTitle>
              {formatSearchResultTitle(mapObject.NAME)}
            </ListViewResultTitle>
          </ListViewResultSection>
          <ListViewResultSection flex="1 1 200px">
            <ListViewResultMeta>{mapObject.STAN || "—"}</ListViewResultMeta>
          </ListViewResultSection>
          <ListViewResultSection flex="1 1 200px">
            <ListViewResultMeta>
              {mapObject.registration_date_1 || "—"}
            </ListViewResultMeta>
          </ListViewResultSection>
        </ListViewResultRow>
      ) : (
        <>
          <img src={Np} alt="" />
          <StyledSearchResultsItemTitle>
            {formatSearchResultTitle(mapObject.NAME)}
          </StyledSearchResultsItemTitle>
          <p>
            {mapObject.STAN} &middot;
            {" " + mapObject.registration_date_1 + " "}
          </p>
        </>
      )}
    </SearchResultItem>
  );
};

export default PersonsSearchResultItem;
